<header class="mv2" [class.mv2-lateral]="layout === 'lateral'" [class.mv2-mobile-submenu]="!!grupoAberto" aria-label="Navegação PromoKit">
  <div class="mv2-principal">
    <button type="button" class="mv2-mobile-toggle" (click)="alternarMobile()" [attr.aria-expanded]="mobileAberto || !!grupoAberto" aria-controls="mv2-nav" aria-label="Abrir ou fechar navegação">
      <i [class]="mobileAberto || grupoAberto ? 'fe-x' : 'fe-menu'" aria-hidden="true"></i>
    </button>
    <button type="button" class="mv2-marca" aria-label="PromoKit — página inicial" (click)="inicio && executar(inicio)">
      <img class="mv2-logo-promokit" src="/assets/fidelidade/promokit-horizontal-branco.png" alt="PromoKit" height="36">
    </button>
    <span class="mv2-divisor" aria-hidden="true"></span>
    <button type="button" class="mv2-operacao-trigger" [class.aberto]="operacaoAberta" (click)="alternarOperacao()"
            [attr.aria-expanded]="operacaoAberta" aria-controls="mv2-operacao"
            [attr.aria-label]="empresa.nome + (empresa.id ? ', empresa ID ' + empresa.id : '') + ': ' + statusLoja + '. Status e controles da loja'">
      <span class="mv2-status" [class.aberta]="lojaAberta && !empresa.fechadoTemporariamente" aria-hidden="true"></span>
      <span class="mv2-identidade"><span class="mv2-nome-empresa">
        <span class="mv2-empresa-id" *ngIf="empresa.id">ID {{empresa.id}} ·</span>
        <strong [title]="empresa.nome">{{empresa.nome || 'Minha loja'}}</strong></span>
        <span class="mv2-status-texto">{{statusLoja}}</span></span>
      <i class="fe-chevron-down" aria-hidden="true"></i><span class="mv2-badge" *ngIf="pendencias">{{pendencias}}</span>
    </button>
    <button type="button" class="mv2-busca-trigger" (click)="abrirBusca()" aria-haspopup="dialog" aria-label="Buscar função">
      <i class="fe-search" aria-hidden="true"></i><span>Buscar função</span><kbd>{{atalho}}</kbd>
    </button>
    <button type="button" class="mv2-ver-cardapio" *ngIf="cardapioPublico" (click)="executar(cardapioPublico)"
            title="Ver minha Loja em outra aba" aria-label="Ver minha Loja em outra aba">
      <i class="fe-external-link" aria-hidden="true"></i><span>Ver minha Loja</span>
    </button>
    <!-- Menu no topo: número e extensão à vista (no lateral eles ficam no cartão da conta). -->
    <div class="mv2-canal-topo" *ngIf="layout === 'topo' && (whatsappPrincipal || extensaoWhatsapp)">
      <button type="button" class="mv2-canal-chip mv2-link-numeros" *ngIf="whatsappPrincipal && numerosWhatsapp"
              title="Abrir números do WhatsApp" (click)="abrirNumerosWhatsapp($event)">
        <i class="fe-phone" aria-hidden="true"></i>{{whatsappPrincipal | tel}}<i class="fe-chevron-right" aria-hidden="true"></i>
      </button>
      <span class="mv2-canal-chip" *ngIf="whatsappPrincipal && !numerosWhatsapp" title="Número usado para atendimento">
        <i class="fe-phone" aria-hidden="true"></i>{{whatsappPrincipal | tel}}
      </span>
      <a class="mv2-canal-chip" *ngIf="extensaoWhatsapp as extensao" [href]="extensao.url" target="_blank" rel="noopener noreferrer"
         [title]="'Este número envia pela ' + extensao.nome + '. Clique para instalar na Chrome Web Store.'">
        <i class="fe-download" aria-hidden="true"></i>{{extensao.rotulo}}<i class="fe-arrow-up-right" aria-hidden="true"></i>
      </a>
    </div>
    <ng-content select="[menuAlertas]"></ng-content>
    <button type="button" class="mv2-avatar" (click)="alternarConta()" [attr.aria-expanded]="contaAberta"
            aria-controls="mv2-conta" [attr.aria-label]="'Conta de ' + usuario?.nome">{{iniciais}}</button>
  </div>

  <nav id="mv2-nav" class="mv2-nav" [class.mv2-mobile-aberto]="mobileAberto" aria-label="Funções do sistema">
    <div class="mv2-lateral-intro" *ngIf="layout === 'lateral'">
      <div class="mv2-aplicativos" *ngIf="atalhosAplicativos.length">
        <button type="button" *ngFor="let item of atalhosAplicativos" (click)="executar(item)"
                [attr.aria-label]="(item.id === 'kds' ? 'KDS' : 'Ver minha Loja') + ' em outra aba'" [title]="item.descricao">
          <i [class]="item.id === 'kds' ? 'fe-monitor' : 'fe-shopping-bag'" aria-hidden="true"></i>
          <span>{{item.id === 'kds' ? 'KDS' : 'Loja'}}</span>
          <i class="fe-external-link" aria-hidden="true"></i>
        </button>
      </div>
      <button type="button" class="mv2-busca-lateral" (click)="abrirBusca()" aria-haspopup="dialog" aria-label="Buscar função">
        <i class="fe-search" aria-hidden="true"></i><span>Buscar função</span><kbd>{{atalho}}</kbd>
      </button>
    </div>
    <ng-container *ngFor="let grupo of grupos">
    <button type="button" class="mv2-nav-item" [id]="'menu-v2-grupo-' + grupo.id"
            [class.ativo]="grupoAtivo === grupo.id" [class.aberto]="(layout === 'lateral' ? grupoLateralAberto : grupoAberto) === grupo.id"
            [attr.aria-current]="grupoAtivo === grupo.id ? 'true' : null"
            [attr.aria-expanded]="grupo.id !== 'inicio' && grupo.id !== 'pay' ? (layout === 'lateral' ? grupoLateralAberto : grupoAberto) === grupo.id : null"
            [attr.aria-controls]="grupo.id !== 'inicio' && grupo.id !== 'pay' ? (layout === 'lateral' ? 'mv2-inline-' + grupo.id : 'mv2-submenu') : null" (click)="alternarGrupo(grupo.id)">
      <i [class]="grupo.icone" aria-hidden="true"></i><span>{{grupo.nome}}</span>
      <span class="mv2-badge" *ngIf="alertaGrupo(grupo.id)">{{alertaGrupo(grupo.id)}}</span>
      <span class="mv2-ponto-novo" *ngIf="!alertaGrupo(grupo.id) && temNovaNoGrupo(grupo.id)" title="Tem função nova aqui"></span>
      <i class="fe-chevron-down mv2-seta" *ngIf="grupo.id !== 'inicio' && grupo.id !== 'pay'" aria-hidden="true"></i>
    </button>
    <div class="mv2-inline" *ngIf="layout === 'lateral' && grupoLateralAberto === grupo.id"
         [id]="'mv2-inline-' + grupo.id" [attr.aria-labelledby]="'menu-v2-grupo-' + grupo.id">
      <section *ngFor="let secao of secoesLaterais">
        <h2 *ngIf="secoesLaterais.length > 1">{{secao.nome}}</h2>
        <button type="button" *ngFor="let item of secao.itens" (click)="executar(item)" [class.mv2-inline-sub]="item.pai"
                [class.selecionado]="itemAtivo(item)" [attr.aria-current]="itemAtivo(item) ? 'page' : null" [title]="item.descricao">
          <i [class]="item.icone + ' mv2-inline-icone'" aria-hidden="true" *ngIf="!item.pai"></i>
          <span>{{item.nome}}</span><small class="mv2-badge" *ngIf="alertaItem(item)">{{alertaItem(item)}}</small><small class="mv2-novo" *ngIf="ehNova(item)">novo</small><small class="mv2-admin" *ngIf="item.interna && !item.pai">Admin</small>
          <i class="fe-arrow-up-right" *ngIf="item.externa" aria-hidden="true"></i>
        </button>
      </section>
    </div>
    </ng-container>
    <!-- Menu que cresce com a loja: o que está guardado continua a um toque, sem encher a navegação -->
    <div class="mv2-descobrir" *ngIf="totalGuardadas || onboardingMenu?.menuCompleto">
      <button type="button" class="mv2-descobrir-topo" *ngIf="totalGuardadas" (click)="descobrirAberto = !descobrirAberto" [attr.aria-expanded]="descobrirAberto">
        <i class="fe-compass" aria-hidden="true"></i><span>Descobrir</span><small>{{totalGuardadas}}</small>
        <i class="fe-chevron-down mv2-seta" aria-hidden="true"></i>
      </button>
      <p class="mv2-descobrir-dica" *ngIf="totalGuardadas && !descobrirAberto">
        Próximo: <b>{{proximasDescobrir}}</b>. {{guardadas[0].quando}}.
      </p>
      <div class="mv2-descobrir-lista" *ngIf="descobrirAberto">
        <section *ngFor="let grupo of guardadas">
          <h2>{{grupo.quando}}</h2>
          <button type="button" *ngFor="let g of grupo.itens" (click)="descubra(g.funcao)" [title]="g.descricao">
            <i [class]="g.funcao.icone" aria-hidden="true"></i><span><strong>{{g.funcao.nome}}</strong><small>{{g.descricao}}</small></span>
          </button>
        </section>
        <button type="button" class="mv2-descobrir-tudo" *ngIf="podeMostrarTudo" (click)="mostreMenuCompleto(true)">Mostrar menu completo</button>
        <p class="mv2-descobrir-dica" *ngIf="podeMostrarTudo">{{ onboardingMenu?.experiente ? 'Você já usou outro sistema: pode liberar tudo de uma vez.' : 'Sua loja já tem ritmo: pode liberar tudo de uma vez.' }}</p>
      </div>
      <button type="button" class="mv2-descobrir-tudo" *ngIf="onboardingMenu?.menuCompleto" (click)="mostreMenuCompleto(false)">Voltar ao menu por fases</button>
    </div>
    <button type="button" class="mv2-atalho-pedidos" *ngIf="funcoes.length && grupos.length" (click)="abrirBusca()">
      <i class="fe-command" aria-hidden="true"></i><span>Buscar funções</span>
    </button>
    <button type="button" class="mv2-nav-item mv2-busca-mobile" (click)="abrirBusca()" aria-haspopup="dialog"><i class="fe-search" aria-hidden="true"></i><span>Buscar função</span></button>
    <button type="button" class="mv2-nav-item mv2-conta-mobile" (click)="alternarConta()"><i class="fe-user" aria-hidden="true"></i><span>Minha conta</span></button>
    <button type="button" class="mv2-menu-antigo-lateral" (click)="onMenuLegado.emit()" title="Voltar para o menu antigo">
      <i class="fe-corner-up-left" aria-hidden="true"></i><span>Voltar ao menu antigo</span>
    </button>
    <div class="mv2-lateral-conta">
      <button type="button" class="mv2-lateral-usuario" (click)="alternarConta(true)" [attr.aria-expanded]="contaAberta" aria-controls="mv2-conta" title="Minha conta">
        <span>{{iniciais}}</span>
        <span>
          <strong>{{usuario?.nome}}</strong>
          <small class="mv2-telefone" *ngIf="whatsappPrincipal && !numerosWhatsapp"><i class="fe-phone" aria-hidden="true"></i>{{whatsappPrincipal | tel}}</small>
          <small *ngIf="!whatsappPrincipal">Minha conta</small>
          <small class="mv2-envio" *ngIf="meioDeEnvio && !extensaoWhatsapp" [class.alerta]="meioDeEnvio.alerta"
                 [title]="'Meio de envio configurado: ' + meioDeEnvio.nome"><i [class]="meioDeEnvio.icone" aria-hidden="true"></i>{{meioDeEnvio.nome}}</small>
        </span>
      </button>
      <!-- Atalhos fora do botão da conta (clicável dentro de <button> não é confiável), mas no mesmo cartão. -->
      <div class="mv2-lateral-atalhos" *ngIf="(whatsappPrincipal && numerosWhatsapp) || extensaoWhatsapp">
        <button type="button" class="mv2-telefone mv2-link-numeros" *ngIf="whatsappPrincipal && numerosWhatsapp"
                title="Abrir números do WhatsApp" (click)="abrirNumerosWhatsapp($event)">
          <i class="fe-phone" aria-hidden="true"></i>{{whatsappPrincipal | tel}}<i class="fe-chevron-right" aria-hidden="true"></i>
        </button>
        <a class="mv2-extensao" *ngIf="extensaoWhatsapp as extensao" [href]="extensao.url" target="_blank" rel="noopener noreferrer"
           [title]="'Este número envia pela ' + extensao.nome + '. Clique para instalar na Chrome Web Store.'">
          <i class="fe-download" aria-hidden="true"></i>{{extensao.rotulo}}<i class="fe-arrow-up-right" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  </nav>

  <div class="mv2-submenu" id="mv2-submenu" *ngIf="layout === 'topo' && grupoAberto" [attr.aria-labelledby]="'menu-v2-grupo-' + grupoAberto">
    <button type="button" class="mv2-submenu-voltar" (click)="grupoAberto = null; mobileAberto = true"><i class="fe-arrow-left" aria-hidden="true"></i>Todas as áreas</button>
    <div class="mv2-submenu-secoes">
      <section class="mv2-secao" *ngFor="let secao of secoes">
        <h2>{{secao.nome}}</h2>
        <button type="button" class="mv2-funcao" *ngFor="let item of secao.itens" (click)="executar(item)" [class.selecionado]="itemAtivo(item)"
                [attr.aria-current]="itemAtivo(item) ? 'page' : null">
          <i [class]="item.icone" aria-hidden="true"></i>
          <span><strong>{{item.nome}} <small class="mv2-badge" *ngIf="alertaItem(item)">{{alertaItem(item)}}</small> <small class="mv2-admin" *ngIf="item.interna">Admin</small></strong><small>{{item.descricao}}</small></span>
          <i class="fe-arrow-up-right mv2-link-externo" *ngIf="item.externa" aria-hidden="true"></i>
        </button>
      </section>
    </div>
  </div>

  <section class="mv2-operacao" *ngIf="pendenciasAbertas" aria-label="Pendências">
    <div class="mv2-painel-titulo"><strong>Pendências</strong><button type="button" class="mv2-fechar" (click)="fecharComFoco()" aria-label="Fechar pendências">×</button></div>
    <button type="button" class="mv2-funcao" *ngFor="let item of funcoesPendentes" (click)="executar(item)">
      <i [class]="item.icone" aria-hidden="true"></i><span><strong>{{item.nome}}</strong><small>{{item.descricao}}</small></span><small class="mv2-badge" *ngIf="quantidadePendente(item)">{{quantidadePendente(item)}}</small>
    </button>
  </section>
  <section id="mv2-operacao" class="mv2-operacao" [hidden]="!operacaoAberta" aria-label="Operação da loja">
    <div class="mv2-painel-titulo"><div><strong>Operação da loja</strong><small>{{empresa.id ? 'ID ' + empresa.id + ' · ' : ''}}{{empresa.nome}}</small></div>
      <button type="button" class="mv2-fechar" (click)="alternarOperacao()" aria-label="Fechar operação da loja"><i class="fe-x" aria-hidden="true"></i></button>
    </div>

    <div class="mv2-estado" [class.mv2-estado-aberta]="resumoLoja.estado === 'aberta'" [class.mv2-estado-pausada]="resumoLoja.estado === 'pausada'"
         [class.mv2-estado-fechada]="resumoLoja.estado === 'fechada'" role="status">
      <span class="mv2-estado-ponto" aria-hidden="true"></span>
      <span class="mv2-estado-texto"><strong>{{resumoLoja.titulo}}</strong><small>{{resumoLoja.detalhe}}</small></span>
    </div>
    <ng-container *ngIf="estadoLoja as acao">
      <button type="button" class="mv2-acao-loja" [class.reabrir]="acao.acao === 'abrirLoja'" (click)="executar(acao)"
              [disabled]="acao.acao === 'abrirLoja' && empresa.reabrindo">
        <i class="fe-power" aria-hidden="true"></i>
        <span>{{acao.acao === 'abrirLoja' ? (empresa.reabrindo ? 'Reabrindo…' : 'Reabrir loja') : 'Fechar loja'}}</span>
        <small *ngIf="acao.acao === 'fecharLoja'">Pausa os pedidos em todos os canais até você reabrir.</small>
        <small *ngIf="acao.acao === 'abrirLoja'">Volta a receber pedidos dentro do horário.</small>
      </button>
    </ng-container>

    <div class="mv2-bloco" *ngIf="servicosHoje.length">
      <h3>Hoje</h3>
      <ul class="mv2-lista">
        <li *ngFor="let servico of servicosHoje" [class.aberto]="servico.aberto">
          <span class="mv2-ponto" aria-hidden="true"></span>
          <span class="mv2-lista-nome">{{servico.nome}}</span>
          <span class="mv2-lista-horario">{{servico.horario}}</span>
          <span class="mv2-lista-detalhe">{{servico.detalhe}}</span>
        </li>
      </ul>
    </div>

    <div class="mv2-bloco" *ngIf="integracoes.length">
      <h3>Parceiros</h3>
      <ul class="mv2-lista">
        <li *ngFor="let parceiro of integracoes" [class.aberto]="parceiro.aberta" [class.com-acao]="parceiro.controlavel || parceiro.tipo === 'ifood'" [title]="parceiro.mensagem">
          <span class="mv2-ponto" aria-hidden="true"></span>
          <span class="mv2-lista-nome">{{parceiro.rotulo}} <small *ngIf="parceiro.nome !== parceiro.rotulo">{{parceiro.nome}}</small></span>
          <span class="mv2-lista-detalhe">{{parceiro.mensagem || (parceiro.desativado ? 'Desativado' : (parceiro.aberta ? 'Aberto' : 'Fechado'))}}</span>
          <button type="button" class="mv2-lista-acao" *ngIf="parceiro.controlavel" (click)="alternarIntegracao(parceiro)" [disabled]="parceiro.processando">
            {{parceiro.processando ? 'Aguarde…' : (parceiro.aberta ? 'Fechar' : 'Abrir')}}
          </button>
          <button type="button" class="mv2-lista-acao" *ngIf="parceiro.tipo === 'ifood'" (click)="alternarIntegracao(parceiro)"
                  title="O status do iFood pode levar até 1 minuto para atualizar" aria-label="Atualizar status do iFood">
            <i class="fe-refresh-cw" aria-hidden="true"></i>
          </button>
          <button type="button" class="mv2-lista-acao" *ngIf="parceiro.tipo === 'opendelivery'" (click)="alternarIntegracao(parceiro)"
                  title="Atualizar status da integração" aria-label="Atualizar status da integração OpenDelivery">
            <i class="fe-refresh-cw" aria-hidden="true"></i>
          </button>
        </li>
      </ul>
    </div>

    <div class="mv2-atalhos-operacao" *ngIf="funcoesPendentes.length || filaImpressao">
      <button type="button" *ngIf="funcoesPendentes.length" (click)="abrirPendencias()" [class.alerta]="pendencias">
        <i class="fe-alert-circle" aria-hidden="true"></i><span>Pendências</span><small class="mv2-badge" *ngIf="pendencias">{{pendencias}}</small>
      </button>
      <button type="button" *ngIf="filaImpressao as fila" (click)="executar(fila)" [title]="fila.descricao">
        <i [class]="fila.icone" aria-hidden="true"></i><span>{{fila.nome}}</span>
      </button>
    </div>

    <button type="button" class="mv2-recarregar" (click)="onRecarregar.emit()" title="Recarrega esta empresa em todas as abas abertas, inclusive em outros computadores">
      <i class="fe-refresh-cw" aria-hidden="true"></i>Recarregar todas as abas da empresa
    </button>
  </section>

  <section class="mv2-conta" id="mv2-conta" *ngIf="contaAberta" [class.mv2-conta-cartao]="contaPeloCartao && layout === 'lateral'" aria-label="Minha conta">
    <div class="mv2-painel-titulo"><div><strong>{{usuario?.nome}}</strong><small>{{empresa.id}} · {{empresa.nome}}</small>
      <span class="mv2-selos">
        <button type="button" class="mv2-whatsapp mv2-link-numeros" *ngIf="whatsappPrincipal && numerosWhatsapp" title="Abrir números do WhatsApp"
                (click)="abrirNumerosWhatsapp($event)"><i class="fe-phone" aria-hidden="true"></i>{{whatsappPrincipal | tel}}<i class="fe-chevron-right" aria-hidden="true"></i></button>
        <small class="mv2-whatsapp" *ngIf="whatsappPrincipal && !numerosWhatsapp" title="Número usado para atendimento"><i class="fe-phone" aria-hidden="true"></i>{{whatsappPrincipal | tel}}</small>
        <small class="mv2-envio" *ngIf="meioDeEnvio && !extensaoWhatsapp" [class.alerta]="meioDeEnvio.alerta"
               [title]="'Meio de envio configurado: ' + meioDeEnvio.nome"><i [class]="meioDeEnvio.icone" aria-hidden="true"></i>{{meioDeEnvio.nome}}</small>
        <a class="mv2-extensao" *ngIf="extensaoWhatsapp as extensao" [href]="extensao.url" target="_blank" rel="noopener noreferrer"
           [title]="'Este número envia pela ' + extensao.nome + '. Clique para instalar na Chrome Web Store.'">
          <i class="fe-download" aria-hidden="true"></i>{{extensao.rotulo}}<i class="fe-arrow-up-right" aria-hidden="true"></i>
        </a>
      </span></div><button type="button" class="mv2-fechar" (click)="fecharComFoco()" aria-label="Fechar minha conta"><i class="fe-x" aria-hidden="true"></i></button></div>
    <button type="button" *ngFor="let item of funcoesConta" (click)="executar(item)"><i [class]="item.icone" aria-hidden="true"></i>{{item.nome}}</button>
    <button type="button" class="mv2-preferencia" (click)="alternarLayout()">
      <i [class]="layout === 'topo' ? 'fe-sidebar' : 'fe-layout'" aria-hidden="true"></i>
      {{layout === 'topo' ? 'Usar menu lateral' : 'Usar menu no topo'}}
    </button>
    <button type="button" class="mv2-menu-legado" (click)="contaAberta = false; onMenuLegado.emit()"><i class="fe-corner-up-left" aria-hidden="true"></i>Voltar ao menu antigo</button>
  </section>
  <div class="mv2-erro" role="alert" *ngIf="erroNavegacao">{{erroNavegacao}}<button type="button" (click)="erroNavegacao = ''" aria-label="Fechar aviso">×</button></div>
</header>
<div class="mv2-lateral-fundo" *ngIf="layout === 'lateral' && mobileAberto" (click)="alternarMobile()" aria-hidden="true"></div>

<app-menu-busca [funcoes]="funcoes" [uso]="uso" (onAbrir)="prepararBusca()" (onExecutar)="executar($event)"></app-menu-busca>
